import { Injectable } from '@angular/core';
import SchemaAsset from '../../../assets/contract-schema/contract-schema.json';
import DisplaySchemaAsset from '../../../assets/contract-schema/contract-ui-schema.json';
import SchemaAssetCleansky from '../../../assets/contract-schema/clean-sky/contract-schema-cleansky.json';
import DisplaySchemaAssetCleansky from '../../../assets/contract-schema/clean-sky/contract-ui-schema-cleansky.json';
import SchemaAssetCleanskyErcot from '../../../assets/contract-schema/clean-sky/contract-schema-cleansky-ercot.json';
import DisplaySchemaAssetCleanskyErcot from '../../../assets/contract-schema/clean-sky/contract-ui-schema-cleansky-ercot.json';
import { configurationSelector, quoteRequestSelector } from '@app/state/app.selectors';
import { Store } from '@ngrx/store';
import { AppState } from '@app/state/app.state';
import { combineLatest } from 'rxjs';
import { ContractSchema } from '../models/ContractSchema';

@Injectable({
  providedIn: 'root',
})
export class ContractSchemaService {
  constructor(
    private store: Store<AppState>
  ) { }


  public getSchema(): ContractSchema {

    let schemaAsset = SchemaAsset;
    let displaySchema = DisplaySchemaAsset

    combineLatest([this.store.select(quoteRequestSelector), this.store.select(configurationSelector)]).subscribe(([quoteRequest, configuration]) => {

      if (configuration.supplierConfiguration.vanityName?.toLowerCase() === 'cleansky') {
        if (quoteRequest.iso?.toLowerCase() === 'ercot') {
          schemaAsset = SchemaAssetCleanskyErcot;
          displaySchema = DisplaySchemaAssetCleanskyErcot
        }
        else {
          schemaAsset = SchemaAssetCleansky;
          displaySchema = DisplaySchemaAssetCleansky
        }
      }
    });

    let schema: ContractSchema = {
      jsonSchema: JSON.stringify(schemaAsset),
      displaySchema: JSON.stringify(displaySchema),
      dgsMappingSchema: "",
      id: undefined
    };

    return schema;
  }
}
